export type ScoreObject = {
  scopeId: number;
};
type ScoreString = string;

export type ScoreType = ScoreObject | ScoreString;

export type ScoreDataType = {
  resultTypeId: number;
  type: string;
  tag: string;
  tagIcon: string;
  tagIconColor: string;
  scores: ScoreType[];
  isShortVersion: boolean;
  lineView: string;
};

export type ResultTypeData = {
  number: number;
  scopeId: number;
  value: number;
};

export type SportCommonProps = {
  sportId: number;
  eventResultId: number;
  byResultType: {
    resultTypeData: ResultTypeData[];
    resultTypeId: number;
  }[];
  total: unknown[];
  isShortVersion: boolean;
  lineView: string;
};

export const isScoreObject = (score: ScoreType): score is ScoreObject =>
  typeof score === 'object';
export const isScoreString = (score: ScoreType): score is ScoreString =>
  typeof score === 'string';
